import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';

/**
 * Login with email and password
 */
export const signInWithEmailPassword = async (email: string, password: string): Promise<{ error?: string, success?: boolean }> => {
  try {
    debugLogger.log(`Attempting to login user: ${email}`);

    await platformApiFetch<{ success: boolean }>('/v1/auth/sign-in', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    
    // If everything is successful, return success
    return { success: true };
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Authentication error';
    console.error("Authentication error:", error);
    return { error: message, success: false };
  }
};
